module.exports = __webpack_public_path__ + "img/evalblue.f4020a22.svg";